/**
 @file
 Use this file to create global custom code.
 */
import Collapse from '../node_modules/bootstrap/js/src/collapse.js';

((Drupal, once, globalUtils) => {
  Drupal.behaviors.siteHeader = {
    attach: () => {
      once('siteHeader', '.site-header').forEach((headerElement) => {
        const burgerLinkElement = headerElement.querySelector('#navbarBurgerLink');
        const navWrapperElement = headerElement.querySelector(
          '#navbarCollapsibleContent',
        );
        const submenuBtnElems
          = headerElement.querySelectorAll('.menu-item__offset');
        const submenuBackBtnElems
          = headerElement.querySelectorAll('.menu-item__back');

        const focusTraps = {};
        let activeFocusTrap = null;

        const {
          enableFocusTrap: enableRootFocusTrap,
          disableFocusTrap: disableRootFocusTrap,
          toggleFocusTrap: toggleRootFocusTrap,
        } = globalUtils.setupFocusTrap(navWrapperElement, burgerLinkElement);

        burgerLinkElement?.addEventListener('click', () => {
          headerElement.classList.toggle('js-menu-active');

          submenuBackBtnElems.forEach((btnElement) => {
            const target = document.querySelector(btnElement.dataset.bsTarget);

            Collapse.getInstance(target)?.hide();
          });

          if (activeFocusTrap) {
            disableRootFocusTrap();
            activeFocusTrap.disableFocusTrap();
            activeFocusTrap = null;
          } else {
            toggleRootFocusTrap();
          }
        });

        // Submenus focus trap management.
        for (const submenuBtnElement of [...submenuBtnElems, ...submenuBackBtnElems]) {
          const { bsTarget } = submenuBtnElement.dataset;
          const submenuWrapperElement = document.querySelector(bsTarget);

          if (!submenuWrapperElement) {
            continue;
          }

          focusTraps[bsTarget] ||= globalUtils.setupFocusTrap(
            submenuWrapperElement,
            burgerLinkElement,
          );

          const { enableFocusTrap, disableFocusTrap } = focusTraps[bsTarget];

          if (submenuBtnElement.classList.contains('menu-item__offset')) {
            submenuBtnElement.addEventListener('click', () => {
              activeFocusTrap = focusTraps[bsTarget];

              disableRootFocusTrap();
              enableFocusTrap();
            });
          } else if (submenuBtnElement.classList.contains('menu-item__back')) {
            submenuBtnElement.addEventListener('click', () => {
              activeFocusTrap = null;

              disableFocusTrap();
              enableRootFocusTrap();
            });
          }
        }

        // Menu close buttons.
        headerElement.querySelectorAll('.js-menu-close').forEach((btnElement) => {
          const target = document.querySelector(btnElement.dataset.closeTarget);

          btnElement.addEventListener('click', () => {
            Collapse.getInstance(target)?.hide();
          });
        });

        // --- Header animations on scroll.

        let lastScrollY = window.scrollY;

        document.addEventListener('scroll', () => {
          const scrollYposition = window.scrollY;

          headerElement.classList.toggle(
            'js-site-header--scroll',
            scrollYposition > 100,
          );
          document.body.classList.toggle(
            'js-scroll-down',
            scrollYposition > lastScrollY,
          );

          lastScrollY = scrollYposition;
        });

        burgerLinkElement?.addEventListener('focus', () => {
          document.body.classList.remove('js-scroll-down');
        });
      });
    },
  };

  Drupal.behaviors.headerDeskMenu = {
    attach: () => {
      // First level of menu, remove show class on siblings elements.
      const menuFirstLevelsOffset = document.querySelectorAll(
        '.menu-item__offset-0',
      );
      // Get siblings elements, helper function.
      const getSiblings = (element) => {
        const nodes = document.querySelectorAll(
          '.menu-item-0.menu-item--expanded',
        );
        return [...nodes].filter((node) => node !== element);
      };

      for (let i = 0, length_ = menuFirstLevelsOffset.length; i < length_; i++) {
        menuFirstLevelsOffset[i].addEventListener('click', (e) => {
          const menuItemExpanded = e.currentTarget.closest(
            '.navigation-blocks__first',
          ); // Also for other menus.
          getSiblings(menuItemExpanded).forEach((sib) => {
            const sibSubMenu = sib.querySelector('.menu-item__offset-0');
            // I didn't use .ariaExpanded becouse it not worked on FF.
            const sibSubMenuOpen = sib
              .querySelector('.menu-item__offset-0')
              .getAttribute('aria-expanded');
            if (sibSubMenuOpen === 'true') {
              sibSubMenu.click();
            }
          });
        });
      }
    },
  };

  Drupal.behaviors.breadcrumbsMobile = {
    attach(context) {
      const breadcrumb = once(
        'breadcrumb',
        document.querySelectorAll('.breadcrumb-item'),
        context,
      );
      const breadcrumbExpand = once(
        'breadcrumbExpand',
        document.querySelector('.breadcrumb-item-expand'),
        context,
      );

      // Hide elements when breadcrumb items are more than 4.
      if (breadcrumb.length > 4) {
        for (let i = 0, length_ = breadcrumb.length; i < length_; i++) {
          if (i > 2 && i < length_ - 1) {
            breadcrumb[i].classList.add('breadcrumb-item--hidden');
          }
        }

        // Show expand element.
        breadcrumbExpand.forEach((item) => {
          item.classList.add('show');
        });
      }

      // Show hidden elements on click of breadcrumb-item-expand element.
      breadcrumbExpand.forEach((breadcrumbExp) => {
        breadcrumbExp.addEventListener('click', () => {
          // Get all the hidden elements.
          const breadcrumbHidden = document.querySelectorAll(
            '.breadcrumb-item--hidden',
          );
          breadcrumbHidden.forEach((item) => {
            item.classList.remove('breadcrumb-item--hidden');
          });

          // Update aria-expanded before hiding the expand button.
          breadcrumbExp.setAttribute('aria-expanded', 'true');

          // Hide expand element.
          breadcrumbExp.classList.remove('show');
        });
      });
    },
  };
})(window.Drupal, window.once, window.caleffiGlobalUtils);
